import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, HeartHandshake, Shield } from 'lucide-react';
const differentiators = [{
  icon: <Target size={28} data-id="element-907" />,
  title: 'Decades of Experience',
  description: 'Our principals bring over 20 years of deep industry expertise, navigating complex recovery scenarios with proven strategies.'
}, {
  icon: <Users size={28} data-id="element-908" />,
  title: 'Boutique-Sized Attention',
  description: "As a specialized agency, we provide unparalleled service and support. You're never just an account number to us."
}, {
  icon: <HeartHandshake size={28} data-id="element-909" />,
  title: 'Quality Customer Care',
  description: "We are dedicated to respectful, professional interactions that protect your brand's reputation while recovering funds."
}, {
  icon: <Shield size={28} data-id="element-910" />,
  title: 'Compliance-First Approach',
  description: 'Strict adherence to all federal and state regulations, ensuring every action we take is legally sound and ethically grounded.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-brand-gray" data-id="element-911">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-912">
        <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-913">
          <div className="lg:col-span-5" data-id="element-914">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-915">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-6" data-id="element-916">
                Why Partner With Compass Recovery Group?
              </h2>
              <p className="text-lg text-brand-muted mb-8 leading-relaxed" data-id="element-917">
                In an industry often characterized by volume over quality, we
                take a different approach. We combine the sophisticated
                capabilities of a large firm with the dedicated, personalized
                service of a boutique agency.
              </p>
              <div className="w-20 h-1 bg-brand-red rounded" data-id="element-918"></div>
            </motion.div>
          </div>

          <div className="lg:col-span-7" data-id="element-919">
            <div className="grid sm:grid-cols-2 gap-6" data-id="element-920">
              {differentiators.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-white p-6 rounded-xl shadow-sm" data-id="element-921">
                  <div className="w-12 h-12 bg-brand-red/10 text-brand-red rounded-lg flex items-center justify-center mb-4" data-id="element-922">
                    {item.icon}
                  </div>
                  <h3 className="text-lg font-bold text-brand-dark mb-2" data-id="element-923">
                    {item.title}
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed" data-id="element-924">
                    {item.description}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}